import React from 'react';
import PropTypes from "prop-types";
import {setupOnExtractData} from "../../../util/FormUtil";

export const PROP_NAME_CAN_CONTACT_FEEDBACK = "canContactFeedback";
//Set dirty and valid since one of the buttons will always be checked.
const canContactFeedbackMetadata = {dirty: true, valid: true};

class CustomerFeedbackInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.setFeedbackAnswer = this.setFeedbackAnswer.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        const {setFormState, metadata, data} = this.props;

        // Init to NO
        if(!metadata[PROP_NAME_CAN_CONTACT_FEEDBACK]) {
            setFormState({property: PROP_NAME_CAN_CONTACT_FEEDBACK, data: data[PROP_NAME_CAN_CONTACT_FEEDBACK] !== undefined ? data[PROP_NAME_CAN_CONTACT_FEEDBACK] : false, metadata: canContactFeedbackMetadata});
        }

        setupOnExtractData(this);
    }

    extractData(){
        const {data} = this.props;
        const result = {};
        result[PROP_NAME_CAN_CONTACT_FEEDBACK] = data[PROP_NAME_CAN_CONTACT_FEEDBACK];
        return result;
    }

    setFeedbackAnswer(e){
        const {setFormState} = this.props;
        setFormState({property: PROP_NAME_CAN_CONTACT_FEEDBACK, data: e.target.value == 'true', metadata: canContactFeedbackMetadata});
    }

    render() {
        const {data} = this.props;
        return (
            <div className={"grid"}>
                <div className={"grid__col-sm-12"}>
                    <ul className={"form-fields check-list list-inline"}>
                        <li className="push--right">
                            <input type={"radio"}
                                   name={PROP_NAME_CAN_CONTACT_FEEDBACK}
                                   id={"canContactFeedbackYes"}
                                   onChange={this.setFeedbackAnswer}
                                   value={true}
                                   checked={data[PROP_NAME_CAN_CONTACT_FEEDBACK]}
                            />
                            <label htmlFor={"canContactFeedbackYes"}>
                                Yes
                            </label>
                        </li>
                        <li className="push--right">
                            <input type={"radio"}
                                   name={PROP_NAME_CAN_CONTACT_FEEDBACK}
                                   id={"canContactFeedbackNo"}
                                   onChange={this.setFeedbackAnswer}
                                   value={false}
                                   checked={! data[PROP_NAME_CAN_CONTACT_FEEDBACK]}
                            />
                            <label htmlFor={"canContactFeedbackNo"}>
                                No
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

CustomerFeedbackInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    onExtractData: PropTypes.func

};

export default CustomerFeedbackInputComponent;

